var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9746 16.4246V20.3246H16.8996L16.8996 22.2746L9.09961 22.2746V20.3246H12.0246L12.0246 16.4246H5.19961C4.94102 16.4246 4.69303 16.3219 4.51018 16.139C4.32733 15.9562 4.22461 15.7082 4.22461 15.4496L4.22461 5.69961C4.22461 5.44102 4.32733 5.19303 4.51018 5.01018C4.69303 4.82733 4.94102 4.72461 5.19961 4.72461L20.7996 4.72461C21.0582 4.72461 21.3062 4.82733 21.489 5.01018C21.6719 5.19303 21.7746 5.44102 21.7746 5.69961V15.4496C21.7746 15.7082 21.6719 15.9562 21.489 16.139C21.3062 16.3219 21.0582 16.4246 20.7996 16.4246L13.9746 16.4246ZM9.09961 9.59961V11.5496L16.8996 11.5496V9.59961L9.09961 9.59961Z",
    fill: "#0E121B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackScreen);
export default __webpack_public_path__ + "static/media/black-screen.c6a57cd6302c3d898d9ec0f4714e76cd.svg";
export { ForwardRef as ReactComponent };